module.exports = __webpack_public_path__ + "img/addCase-result.a19ed184.png";